import React from "react";

const CameraIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M6 1C6 0.448 6.413 0 6.923 0H13.077C13.587 0 14 0.448 14 1C14 1.552 13.587 2 13.077 2H6.923C6.413 2 6 1.552 6 1ZM7.778 18H12.222C15.343 18 16.904 18 18.025 17.278C18.5073 16.9679 18.9239 16.5659 19.251 16.095C20 15.015 20 13.51 20 10.5C20 7.49 20 5.986 19.25 4.905C18.9232 4.43412 18.507 4.03214 18.025 3.722C16.904 3 15.343 3 12.222 3H7.778C4.657 3 3.096 3 1.975 3.722C1.49302 4.03216 1.07678 4.43413 0.75 4.905C0 5.985 0 7.49 0 10.498V10.5C0 13.51 5.96046e-08 15.014 0.749 16.095C1.073 16.563 1.489 16.965 1.975 17.278C3.096 18 4.657 18 7.778 18ZM5.833 10.5C5.833 8.28 7.699 6.482 10 6.482C12.301 6.482 14.167 8.281 14.167 10.5C14.167 12.719 12.3 14.518 10 14.518C7.699 14.518 5.833 12.718 5.833 10.5ZM7.5 10.5C7.5 9.168 8.62 8.09 10 8.09C11.38 8.09 12.5 9.169 12.5 10.5C12.5 11.831 11.38 12.91 10 12.91C8.62 12.91 7.5 11.831 7.5 10.5ZM16.111 6.482C15.651 6.482 15.278 6.842 15.278 7.286C15.278 7.729 15.651 8.089 16.111 8.089H16.667C17.127 8.089 17.5 7.729 17.5 7.286C17.5 6.842 17.127 6.482 16.667 6.482H16.111Z" fill="currentColor" />
    </svg>
  );
};

export default CameraIcon;

